import { useState } from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import { uploadFile } from "../../../services/upload";
import { resolveUploadErrors } from "../../pages/lessons/lessonFileUpload";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  InnerLoading,
  Image,
  Div,
  Text,
} from "../../core";
import { Upload } from "../../patterns";

export const ImageEdit = ({ content: oldContent, handleClose, handleSave }) => {
  const { value = {} } = oldContent;

  const [content, setContent] = useState(value);
  const [uploadProgress, setUploadProgress] = useState(null);
  const [uploadError, setUploadError] = useState(null);
  const { url, caption } = content;

  const handleChange = ({ target }) => {
    const { name, value: fieldValue } = target;
    setContent({
      ...content,
      [name]: fieldValue,
    });
  };

  const beginUpload = () => {
    setUploadError(null);
    setUploadProgress(0);
    setContent((prev) => ({ ...prev, fileLoading: true }));
  };

  const clearUpload = () => {
    setUploadProgress(null);
    setContent((prev) => ({ ...prev, fileLoading: false }));
  };

  const handleUploadFile = async (file) => {
    const selected = file?.[0];
    if (!selected) {
      clearUpload();
      return;
    }

    beginUpload();

    try {
      const data = await uploadFile(selected, {
        onProgress: (pct) => setUploadProgress(pct),
      });
      setContent((prev) => ({
        ...prev,
        url: data.url,
        fileLoading: false,
      }));
      setUploadProgress(null);
      setUploadError(null);
    } catch (err) {
      setUploadError(resolveUploadErrors(err));
      clearUpload();
    }
  };

  return (
    <Dialog open={true} fullWidth>
      <DialogTitle>Edição da Imagem</DialogTitle>
      <DialogContent>
        {!content.url && (
          <Div>
            {content.fileLoading && <InnerLoading />}
            {uploadProgress != null && (
              <div
                data-testid="upload-progress-image"
                style={{ marginBottom: 12 }}
              >
                <LinearProgress
                  variant="determinate"
                  value={
                    typeof uploadProgress === "number" ? uploadProgress : 0
                  }
                />
                <Text style={{ display: "block", marginTop: 4 }}>
                  {`${typeof uploadProgress === "number" ? uploadProgress : 0}%`}
                </Text>
              </div>
            )}
            {uploadError && (
              <div data-testid="upload-error-image" style={{ marginBottom: 12 }}>
                {(uploadError || []).map((item, key) => (
                  <Text key={key} color="error" style={{ display: "block" }}>
                    {item.message || item}
                  </Text>
                ))}
              </div>
            )}
            <Upload
              label="Imagem"
              value={url}
              fullwidth
              name="url"
              acceptedFiles={["image/*"]}
              dropzoneText={"Arraste e solte seu arquivo ou clique aqui"}
              onChange={handleUploadFile}
              showPreviewsInDropzone={false}
              filesLimit={1}
              onDrop={beginUpload}
            />
          </Div>
        )}
        {content.url && (
          <Div style={{ display: "flex", flexDirection: "column" }}>
            <Image
              alt={content.name}
              src={content.url}
              style={{ maxWidth: 200 }}
            />
            <Button
              style={{ marginTop: 10 }}
              variant="outlined"
              color="secondary"
              onClick={() => setContent({ ...content, url: null })}
            >
              Remover Imagem
            </Button>
          </Div>
        )}
        <TextField
          label="Legenda"
          value={caption}
          onChange={handleChange}
          style={{ marginTop: 10 }}
          fullWidth
          name="caption"
        />
      </DialogContent>
      <DialogActions>
        <Button
          size="small"
          variant="outlined"
          color="primary"
          onClick={handleClose}
        >
          Cancelar
        </Button>
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={() => {
            handleSave(content);
            handleClose();
          }}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
